import { RenovationType } from '@entities/hotel';
import { ChildServiceFilterItem, RestTypeFilterItem, BeachTypeFilterItem } from '../types';

export interface IFilterHotelsState {
    childServiceFilterIds: ChildServiceFilterItem['id'][];
    restTypeFilterId: RestTypeFilterItem['id'] | 0;
    beachTypeFilterIds: BeachTypeFilterItem['id'][];
    renovations: RenovationType[]
}

export interface IFilterHotersMutations {
    setChildServiceFilter(state: IFilterHotelsState, value: ChildServiceFilterItem['id'][]): void;
    setRestTypeFilter(state: IFilterHotelsState, value: RestTypeFilterItem['id'] | 0): void;
    setBeachTypeFilter(state: IFilterHotelsState, value: BeachTypeFilterItem['id'][]): void;
    setRenovations(state: IFilterHotelsState, value: RenovationType[]): void;
}

const DefaultState = (): IFilterHotelsState => ({
    childServiceFilterIds: [],
    restTypeFilterId: 0,
    beachTypeFilterIds: [],
    renovations: [],
});

export default {
    namespaced: true,
    state: DefaultState(),
    mutations: {
        setChildServiceFilter(state: IFilterHotelsState, value: ChildServiceFilterItem['id'][]) {
            state.childServiceFilterIds = value;
        },
        setRestTypeFilter(state: IFilterHotelsState, value: RestTypeFilterItem['id'] | 0) {
            state.restTypeFilterId = value;
        },
        setBeachTypeFilter(state: IFilterHotelsState, value: BeachTypeFilterItem['id'][]) {
            state.beachTypeFilterIds = value;
        },
        setRenovations(state: IFilterHotelsState, value: RenovationType[]) {
            state.renovations = value;
        }
    },
};

export const NAMESPACE = 'filterHotelsNameModel';
